// Import the LitElement base class and html helper function
import { LitElement, html } from 'lit-element';
import { ProductJeunessecardItem } from './product-jeunessecard-item';

// Extend the LitElement base class
class ProductJeunessecard extends LitElement {

  static get properties() {
    return {
      amountCards: { type: Number },
      cardTypes: { type: Object },
      selectedCardType: { type: String },
      jeunessecardItem: { type: Object },
      shadowdomstyle: { type: String },
      addjeunessecardtocart: { type: String}
    };
  }

  constructor() {
    super();
    this.amountCards = 1;
    this.cardTypes = {'card26':'JEUNESSE CARD.26 | € 26,00', 'cardClassic':'JEUNESSE CARD.classic | € 45,00', 'cardPlus':'JEUNESSE CARD.plus | € 145,00', 'cardPremium':'JEUNESSE CARD.premium | € 1.450,00'};
  }

  changeAmountCards(value) {
    this.amountCards = value;
  }

  changeTypeCard(value) {
    this.selectedCardType = value;
  }

  addJeunesseCard() {
    if(this.selectedCardType && this.selectedCardType != 'empty') {
      this.jeunessecardItem = new ProductJeunessecardItem(this.selectedCardType, this.cardTypes[this.selectedCardType], this.amountCards);
    }
  }

  jeunessecardItemTemplate() {
    return html`
      <div id="jeunessecard-item-1"> 
        <input type="hidden" name="tx_cart_cart[productType]" value="MemberCard">
        <input type="hidden" name="tx_cart_cart[membercard]" value="${this.selectedCardType}">
        <input class="form-control" 
                type="hidden"
                id="abo-quantity"
                value="1" 
                min="1" 
                max="1"
                name="tx_cart_cart[quantity]">
        ${this.jeunessecardItem.render()}
        <div class="form-row mt-5">
          <div class="col text-right">
              <input @click="${this.removeJeunesseCard}" class="btn btn-secondary mt-auto" value="Karten entfernen">
              <input type="submit" class="btn btn-primary mt-auto" onclick="javascript:setStickyCartButton(event)" value="${this.addjeunessecardtocart}">
          </div>
        </div>
      </div>
    `;
  }

  removeJeunesseCard() {
    this.jeunessecardItem = null;
  }

  /**
   * Implement `render` to define a template for your element.
   *
   * You must provide an implementation of `render` for any element
   * that uses LitElement as a base class.
   */
  render(){
    /**
     * `render` must return a lit-html `TemplateResult`.
     *
     * To create a `TemplateResult`, tag a JavaScript template literal
     * with the `html` helper function:
     */
    return html`
      <link rel="stylesheet" href="${this.shadowdomstyle}">
      <div class="add-to-cart-form">
        <div class="form-row">
          <div class="col-lg-2">
            <label for="abo-quantity">Anzahl</label>
            <input class="form-control" id="abo-quantity" type="number" value="${this.amountCards}" @change=${e => this.changeAmountCards(e.target.value)} min="1" max="10">
          </div>
          <div class="col-lg-7">
            <label for="abo-categories">Kategorie &amp; Preise</label>
            <select id="abo-categories" class="form-control" name="tx_cart_cart[priceCategory]" @change=${e => this.changeTypeCard(e.target.value)}>
              <option selected value="empty">Bitte wählen</option>
              ${Object.keys(this.cardTypes).map(item => html`<option value="${item}">${this.cardTypes[item]}</option>`)}
            </select>
          </div>
          <div class="col-lg-3 d-flex align-items-end flex-column">
            <input @click="${this.addJeunesseCard}" class="btn btn-primary mt-auto" value="Auswahl hinzufügen">
          </div>
        </div>
        ${this.jeunessecardItem ? 
          this.jeunessecardItemTemplate() : 
          html``}
      </div>
    `;
  }

}
// Register the new element with the browser.
customElements.define('product-jeunessecard', ProductJeunessecard);